import { render, staticRenderFns } from "./editPartnerPool.vue?vue&type=template&id=ed6b5192"
import script from "./editPartnerPool.vue?vue&type=script&lang=js"
export * from "./editPartnerPool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports